module.exports = __webpack_public_path__ + "img/sun.4ea6774f.svg";